/**
 * DashboardArceInlineController — saisie inline de la 2ᵉ tranche ARCE
 * dans le bloc Aides du dashboard payant §15.B (EPIC-032 / 32.5).
 *
 * Cohabite sur la racine `dashboard-payant-template` avec le controller
 * `dashboard-payant`. Lié au `<form>` posé dans le sous-bloc
 * `data-aid="arce"` (visible côté JS uniquement quand
 * `arceSecondPaymentDueDate − 7 jours ≤ today`).
 *
 * Sur soumission : PATCH /me/profile/arce-second-payment puis
 * dispatch `dashboard-arce-inline:success` pour que `dashboard-payant`
 * refetch `/dashboard/me` et rafraîchisse le bloc Aides.
 *
 * Validation 422 : agrège les erreurs `fields[]` champ par champ
 * sous le `<input>` correspondant via les `nm-field__error[data-field]`.
 */

import BaseController from "./base_controller.js";
import { api } from "/js/services/api.js";

export default class DashboardArceInlineController extends BaseController {
  static targets = ["form", "dateInput", "amountInput", "submitButton", "formError"];

  async submit(event) {
    event.preventDefault();
    this._clearErrors();

    const receivedDate = this.hasDateInputTarget ? this.dateInputTarget.value.trim() : "";
    const amount = this.hasAmountInputTarget ? this.amountInputTarget.value.trim() : "";

    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = true;

    try {
      const payload = await api.updateArceSecondPayment(receivedDate, amount);
      this.dispatch("success", { detail: payload });
      this.showSuccess("Réception de la 2ᵉ tranche ARCE enregistrée.");
    } catch (error) {
      this._renderError(error);
    } finally {
      if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = false;
    }
  }

  _renderError(error) {
    const status = error && typeof error === "object" ? error.status : null;
    if (status === 422 && error.details && Array.isArray(error.details.fields)) {
      for (const entry of error.details.fields) {
        this._applyFieldError(entry);
      }
      return;
    }
    const message = error && typeof error.message === "string" && error.message !== ""
      ? error.message
      : "Erreur lors de l'enregistrement. Réessayez plus tard.";
    if (this.hasFormErrorTarget) {
      this.formErrorTarget.textContent = message;
      this.formErrorTarget.hidden = false;
    } else {
      this.showError(message);
    }
  }

  _applyFieldError(entry) {
    if (!entry || typeof entry.field !== "string") return;
    const errorEl = this.element.querySelector(
      `.nm-field__error[data-field="${entry.field}"]`,
    );
    if (errorEl) {
      errorEl.textContent = entry.message || "Champ invalide.";
      errorEl.hidden = false;
    }
  }

  _clearErrors() {
    const errors = this.element.querySelectorAll(".nm-field__error[data-field]");
    for (const node of errors) {
      node.textContent = "";
      node.hidden = true;
    }
    if (this.hasFormErrorTarget) {
      this.formErrorTarget.textContent = "";
      this.formErrorTarget.hidden = true;
    }
  }
}
